import clsx from 'clsx';
import { forwardRef } from 'react';

import { DataTestId } from '../../../core/types/data-props.js';
import { StylingProps } from '../../../core/types/styling-props.js';
import { WithChildren } from '../../../core/types/with-children.js';
import { visualSlotCss } from '../EmptyState.sty.js';
import { visualContainerCSS } from './Visual.sty.js';

//#region Typings
/**
 * @public
 */
export interface EmptyStateVisualProps
  extends WithChildren, StylingProps, DataTestId {}
//#endregion Typings

/**
 * Container for the Visual slot of the EmptyState component.
 * @public
 */
export const Visual = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  EmptyStateVisualProps
>((props, forwardedRef) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  } = props;

  return (
    <div
      ref={forwardedRef}
      className={clsx([visualContainerCSS, visualSlotCss, consumerClassName])}
      style={consumerStyle}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
});

(Visual as typeof Visual & { displayName: string }).displayName =
  'EmptyState.Visual';
